import initialState from './initialState';
import { types } from '../actions/budgetAuthActions';
//import { types as accountTypes } from '../actions/accountsActions';

export default function budgetAuthReducer(state = initialState.budgetAuth, action) {
  let newState;
  switch (action.type) {
    case types.BUDGET_SIGN_IN_SUCCESS: {
      newState = Object.assign({}, state);
      newState.signedIn = true;
      return newState;
    }
    case types.BUDGET_SIGN_IN_FAILURE: {
      return state;
    }
    case types.BUDGET_SIGNED_OUT: {
      newState = Object.assign({}, state);
      newState.signedIn = false;
      return newState;
    }
    /*case accountTypes.DELETE_ACCOUNT_SUCCESS: {
      newState = Object.assign({}, state);
      newState.signedIn = false;
      return newState;
    }*/
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetAuthReducer.js